export const REDIRECT_URL = 'https://mrvc-pk.siso.net';